import React from "react";
import { useState,useEffect } from "react";
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './classes/ApparelOrderStatusLog.css';
import { DataGrid } from '@mui/x-data-grid';
import { configData } from "../config";
import { Link } from '@mui/material';
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";


const columns = [
    {
        field: 'order_number',
        headerName: 'Order Number',  
        headerClassName:'order_number_header',    
        flex:1,
        sortable:false,
        renderCell: (params) => (
            <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
                {params.row.order_number}
            </Link>
        ),
    },
    {
        field: 'description',
        headerName: 'Description',
        cellClassName:'description_column',headerClassName:'description_header',   
        flex:1, 
        minWidth: 314,
        sortable:false,    
    },
    {
        field: 'created_at',
        headerName: 'Created At',   
        headerClassName:'created_at_header',
        flex:1,
        sortable:false,
    },
    {
        field: 'updated_by',
        headerName: 'Created By',   
        headerClassName:'created_by_header',
        flex:1,
        sortable:false,
    }
];

// const rows = [
//   { order_number: 1, description: 'Apple', created_at: '2025-01-27', created_by: 'Smith' },
//   { order_number: 2, description: 'Banana', created_at: '2025-02-27', created_by: 'Misa' },
//   { order_number: 3, description: 'Carrot', created_at: '2025-03-27', created_by: 'Light' },
//   { order_number: 4, description: 'Mango', created_at: '2025-04-27', created_by: 'L' },
//   { order_number: 5, description: 'Broccoli', created_at: '2025-05-27', created_by: 'Sam' },
// ];

const ApparelOrderStatusLog = () => {

    const [isLoading, setIsLoading] = useState(true);
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });

    // const [searchTerm, setSearchTerm] = useState('');
    const [searchValue, setSearchValue] = useState('');

    const app_url = configData.APP_URL;

    // Filter rows based on search term
    // const filteredRows = searchTerm.trim()
    // ? rows.filter((row) => {
    //     const order_number = String(row.order_number || '').toLowerCase();
    //     const description = String(row.description || '').toLowerCase();
    //     const created_at = String(row.created_at || '').toLowerCase();
    //     const created_by = String(row.created_by || '').toLowerCase();
    //     const search = searchTerm.trim().toLowerCase();

    //     return (
    //         order_number.includes(search) ||
    //         description.includes(search) ||
    //         created_at.includes(search) ||
    //         created_by.includes(search)
    //     );
    //     })
    // : rows;
    const fetchData = async () => {
        try {
            // setIsLoading(true);
            const response = await fetch(app_url+'smwwcommerceapparel/apparelorderstatusloglist', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                page: paginationModel.page,
                pageSize: paginationModel.pageSize,
                sortModel,
                filterModel
                }),
            });
            const data = await response.json();
            // console.log(data.data.rows);
            setRows(data.data.rows);
            setRowCount(data.data.totalRowCount); // Server should return totalRowCount
            
        }  catch (error) {
            console.error('Error fetching data:', error);
        // } finally {
        //     setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }         
    };
    
    // React.useEffect(() => {
    //     fetchData();
    // }, [paginationModel, sortModel, filterModel]); // Re-fetch data when these change 
    React.useEffect(() => {
        if (searchValue.trim() === '') {
        Promise.all([
           fetchData(),
        ])
        .then(() => {
        setIsLoading(false);
        })}
    }, [paginationModel, sortModel, filterModel, searchValue]);

    useEffect(() => {
        const fetchQueryData = async () => {
        if (searchValue.trim() !== '') {
        //     fetchData();
        //     return;
        // }
        try {
            const response = await fetch(app_url+'smwwcommerceapparel/apparelorderstatusloglist', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  page: paginationModel.page,
                  pageSize: paginationModel.pageSize,
                  query:searchValue
                //   sortModel,
                //   filterModel
                }),
              });
            const data = await response.json();
            setRows(data.data.rows);
            setRowCount(data.data.totalRowCount);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        }
        };
        const handler = setTimeout(() => {
        fetchQueryData();
        }, 500); 

        return () => {
        clearTimeout(handler);
        };
    }, [searchValue, paginationModel]);

    return (
        <>
         {isLoading ? (
              <Loading />
            ) : (
                <div id="main">
                    <Helmet><title>Apparel Order Status Log</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="order-status-log-container">
                            <div style={{fontWeight:"bold", borderBottom:"1px solid #ddd"}}>
                                <div style={{padding: "10px 15px"}}>Apparel Order Status Log</div>
                            </div>
                            <div style={{padding: "15px"}}>
                                <div style={{textAlign:"right"}} className="order-status-log-search">
                                    <label style={{fontWeight:"normal"}}>
                                        Search:
                                        <input 
                                            type="search" 
                                            className="" 
                                            placeholder="" 
                                            aria-controls="example" 
                                            value={searchValue} 
                                            // onChange={(e) => setSearchTerm(e.target.value)} 
                                            onChange={(e) => setSearchValue(e.target.value)}
                                        />
                                    </label>
                                </div>
                            
                            <div className="" >
                                <table className="order-status-log-table">
                                    <div>
                                        <DataGrid
                                            rows={rows}
                                            columns={columns}
                                            rowCount={rowCount}
                                            paginationMode="server"
                                            sortingMode="server"
                                            filterMode="server"
                                            paginationModel={paginationModel}
                                            onPaginationModelChange={setPaginationModel}
                                            sortModel={sortModel}
                                            onSortModelChange={setSortModel}
                                            filterModel={filterModel}
                                            onFilterModelChange={setFilterModel}
                                            pageSizeOptions={[5, 10, 25,50]}
                                            getRowId={() => crypto.randomUUID()}
                                            getRowHeight={() => 'auto'}
                                            disableColumnFilter 
                                            // disableColumnResize={true}
                                        />
                                    </div>
                                </table>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        <SalespersonSidebar />
                    </div>
                </div>
            )}
        </>
    );
};

export default ApparelOrderStatusLog;